import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //页面跳转显示在顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: '视频教学'
      },
      component: ()=>import('@/pages/home/index')
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '搜索'
      },
      component: ()=>import('@/pages/home/search')
    },
    {
      path: '/result',
      name: 'result',
      meta: {
        title: '搜索结果'
      },
      component: ()=>import('@/pages/home/search_result')
    },
    {
      path: '/detail',
      name: 'detail',
      meta: {
        title: '教学详情'
      },
      component: ()=>import('@/pages/home/detail')
    },
    {
      path: '/subscribe_success',
      name: 'subscribe_success',
      meta: {
        title: '订阅成功'
      },
      component: ()=>import('@/pages/home/subscribe_success')
    },
    {
      path: '/pay_success',
      name: 'subscribe_success',
      meta: {
        title: '支付成功'
      },
      component: ()=>import('@/pages/home/pay_success')
    },
    {
      path: '/subscribe_list',
      name: 'subscribe_list',
      meta: {
        title: '订阅教学'
      },
      component: ()=>import('@/pages/home/subscribe_list')
    },
    {
      path: '/bind_mobile',
      name: 'bind_mobile',
      meta: {
        title: ''
      },
      component: ()=>import('@/pages/home/bind_mobile')
    },
    {
      path: '/member_center',
      name: 'member_center',
      meta: {
        title: '会员中心'
      },
      component: ()=>import('@/pages/user/member_center')
    },
    {
      path: '/member',
      name: 'member',
      meta: {
        title: '我的'
      },
      component: ()=>import('@/pages/user/member')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js